import React from 'react';

export default function NotFoundView() {
    return (
        <React.Fragment>
            <p>Not Found</p>
        </React.Fragment>
    );
}
